import { Directive, Input } from '@angular/core';
import { IFieldHost } from '../../_models/IFieldHost';

/**
 * Fournit le contexte IFieldHost aux <app-field-wrapper> descendants.
 * À poser UNE fois sur la racine du formulaire d'un écran de détail :
 *
 *   <div class="..." [fieldContext]="this">
 *     <app-field-wrapper property="name"> ... </app-field-wrapper>
 *   </div>
 *
 * Un sous-arbre (ex. un modal éditant une autre entité) peut poser son propre
 * [fieldContext] : il masque alors le contexte parent pour ses descendants.
 */
@Directive({
  selector: '[fieldContext]',
  standalone: true
})
export class FieldContextDirective {
  @Input('fieldContext') host!: IFieldHost;
}
